import { NgModule } from '@angular/core';
import { ComponentStylingDirective } from './component-disable.directive';
import { AnimationDirective } from './animation.directive';

const directives = [
  ComponentStylingDirective,
  AnimationDirective,
];

@NgModule({
  declarations: directives,
  exports: directives
})
export class DirectivesModule { }
